import React from 'react'
import PropTypes from 'prop-types'
import './style.css'

const ProgressBar = (props) => {

    return (
        <React.Fragment>
            <div className="bar-progress">
                <span style={{
                    right: `${(100 - props.porcentage)}%`
                }}/>
            </div>
        </React.Fragment>
    )
}

ProgressBar.propTypes = {
    imgSrc: PropTypes.number,
    porcentage: PropTypes.number,
}

ProgressBar.defaultProps = {
    porcentage: 80
}

export default ProgressBar



// WEBPACK FOOTER //
// ./src/components/_ead/ProgressBar/index.js